"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantBanner = exports.ASSISTANT_BANNERS = void 0;
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
require("./assistant-banner.scss");
/**
 * The reasons the sidebar puts a red notice above the composer. One member per reason, so
 * the caller can decide which single one wins when several are true at once.
 */
var ASSISTANT_BANNERS;
(function (ASSISTANT_BANNERS) {
    // The agent has forgotten this conversation; the way out is a new one.
    ASSISTANT_BANNERS["EXPIRED"] = "EXPIRED";
    // The workspace has spent its credits. The way out is a top-up, which has no frontend yet —
    // until it has one, this variant has nothing to press.
    ASSISTANT_BANNERS["QUOTA"] = "QUOTA";
    // This manager has had their conversations for today. The workspace may still hold credits;
    // the cap exists so one curious person cannot drain a shared pool before lunch.
    ASSISTANT_BANNERS["DAILY_LIMIT"] = "DAILY_LIMIT";
})(ASSISTANT_BANNERS || (exports.ASSISTANT_BANNERS = ASSISTANT_BANNERS = {}));
// Key names, not translated strings: `t()` at module scope can resolve before i18next has
// initialised and would bake the key name in permanently.
//
// `actionKey: null` is a variant with no way forward, not a variant whose button is missing:
// offering a dead control would be worse than offering none. DAILY_LIMIT is the one that stays
// that way, because waiting is the only cure for it.
const BANNER_COPY = {
    [ASSISTANT_BANNERS.EXPIRED]: {
        messageKey: 'ASSISTANT.conversationExpired',
        actionKey: 'ASSISTANT_RESTART_CONVERSATION',
    },
    [ASSISTANT_BANNERS.QUOTA]: {
        // The same sentence the usage panel shows for the same fact — one string, one meaning.
        messageKey: 'ASSISTANT.usageQuotaExhausted',
        // Offered only to whoever may actually spend the organization's money: the caller passes no
        // `onAction` for anyone else, and the button disappears with it rather than failing on press.
        actionKey: 'ASSISTANT.usageBuyCredits',
    },
    [ASSISTANT_BANNERS.DAILY_LIMIT]: {
        messageKey: 'ASSISTANT.usageDailyLimitReached',
        actionKey: null,
    },
};
/**
 * Why the manager cannot send right now, and the one thing that fixes it.
 *
 * A normal row between the message list and the composer — deliberately not sticky and never
 * over the thread. A sticky element above the chat library's scroll viewport has to register
 * its height with that viewport or autoscroll silently under-scrolls mid-stream; a plain row
 * needs none of that.
 *
 * The message is a plain `span` rather than `Text` because the design's 11 px has no
 * `Text.TYPES` and its red is not `$color-red`.
 */
const AssistantBanner = ({ variant, onAction, testid, }) => {
    const { messageKey, actionKey } = BANNER_COPY[variant];
    return (react_1.default.createElement("div", { className: 'ds-ma-banner', "data-testid": testid },
        react_1.default.createElement("span", { className: 'ds-ma-banner-text' }, (0, util_1.t)(messageKey)),
        (0, util_1.isValue)(actionKey) && (0, util_1.isValue)(onAction) && (react_1.default.createElement(_ui_1.Button, { label: (0, util_1.t)(actionKey), onClick: onAction, size: _ui_1.Button.SIZES.SMALL, color: _ui_1.Button.COLORS.RED, style: _ui_1.Button.STYLES.CONTAINED }))));
};
exports.AssistantBanner = AssistantBanner;
